module.exports = __webpack_public_path__ + "img/097.499b27b5.png";